document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.olympiad-registration__form').forEach((form) => {
    const agreement = form.querySelector('.olympiad-registration__agreement-input');
    const submitButton = form.querySelector('.olympiad-registration__submit[type="submit"]');

    if (!agreement || !submitButton) return;

    const updateSubmitState = () => {
      const isAllowed = agreement.checked;

      submitButton.disabled = !isAllowed;
      submitButton.setAttribute('aria-disabled', String(!isAllowed));
    };

    agreement.addEventListener('change', updateSubmitState);
    form.addEventListener('reset', () => requestAnimationFrame(updateSubmitState));
    updateSubmitState();
  });
});
